
// 德国时间：11月18日0:00
// 北京时间：11月19日早上7:00

var data=new Date('2022-11-19 07:00:00');
var daysFromNow = (data.getTime() / 1000);
var hasFlipdownClassName =  document.getElementsByClassName("image-container")[0].classList;
var flipdown = new FlipDown(daysFromNow, {
    headings: ['Tage', 'Stunden', 'Minuten'], // 配置多语言
})
  .start()
  .ifEnded(() => {
      // 倒计时结束后，移除DOM
      var flipdown = document.querySelector('#flipdown');
      var flipdownTit = document.querySelector('.flipdown-tit');
      if(flipdown) {
        flipdownTit.remove();
        flipdown.remove();
        hasFlipdownClassName.remove('hasFlipdown')
      }
  });